// IMPORTS
// OHS
import OHSBarGauge from '../../../../../onehivesystems/js/OHSBarGauge';


// COMPONENT
export default function BarGauge (props) {
   return (
      <div className='oneport-dashboard-bargraph-item'>
         <div className='oneport-dashboard-bargraph-item-gauge'>
            <div className='oneport-dashboard-bargraph-item-gauge-title'>
               <p>{props.title}</p>
            </div>
            <OHSBarGauge onehive={props.onehive} current={props.current} max={props.max} threshold={true} />
         </div>
         <div className='oneport-dashboard-bargraph-item-data'>
            <p>{props.current} out of {props.max} ports</p>
         </div>
      </div>
   );
}